import type { AppDispatch } from '@/store/store'
import { fetchAndStoreUserFiles } from '@/user_files/files/utils/fetch-and-store-user-files'
import { ArtifactTemplatesActions } from '@/artifact-templates/store/slice'
import type { ArtifactTemplateSelectionRead, ArtifactVersionAppliedTemplateRead } from '@/artifact-templates/schemas'

/**
 * Merge a conversation's persisted template state into the store on load:
 *  - per-artifact selections and per-version applied records (kept by id), and
 *  - the referenced template UserFile records, so the toolbar can resolve their display names —
 *    template state stores ids only, and a fresh conversation load doesn't otherwise load the files.
 *
 * The file fetch is fire-and-forget and isolated: the name fills in once it resolves, and a failure
 * there must never fail conversation loading.
 */
export function hydrateConversationTemplateState(
  selections: ArtifactTemplateSelectionRead[],
  appliedTemplates: ArtifactVersionAppliedTemplateRead[],
  dispatch: AppDispatch
): void {
  if (selections.length > 0) dispatch(ArtifactTemplatesActions.upsertTemplateSelections(selections))
  if (appliedTemplates.length > 0) dispatch(ArtifactTemplatesActions.upsertAppliedTemplates(appliedTemplates))

  const templateFileIds = [
    ...selections.map((selection) => selection.template_user_file_id),
    ...appliedTemplates.map((applied) => applied.template_user_file_id),
  ].filter((id): id is string => Boolean(id))

  if (templateFileIds.length > 0) {
    fetchAndStoreUserFiles(templateFileIds, dispatch).catch(() => undefined)
  }
}
